var React = require('react');

function TocClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M283.61-657.52v355.04L461.7-480 283.61-657.52Zm-76.83 556.74q-44.3 0-75.15-30.85-30.85-30.85-30.85-75.15v-546.44q0-44.3 30.85-75.15 30.85-30.85 75.15-30.85h546.44q44.3 0 75.15 30.85 30.85 30.85 30.85 75.15v546.44q0 44.3-30.85 75.15-30.85 30.85-75.15 30.85H206.78Zm437.74-106h108.7v-546.44h-108.7v546.44Zm-106 0v-546.44H206.78v546.44h331.74Zm106 0h108.7-108.7Z"}));
}

TocClose.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = TocClose;

TocClose.default = TocClose;
